import * as React from "react";
import { DEFAULT_ARTICLE_DATA } from "../utils/constants/common/defaultArticleData";
import { IArticleData } from "../utils/interfaces/common/XArticle.interfaces";

export const XArticleContext =
  React.createContext<IArticleData>(DEFAULT_ARTICLE_DATA);

const XArticleProvider: React.FC<{
  data?: IArticleData;
  children?: React.ReactNode;
}> = ({ children, data }) => {
  return (
    <XArticleContext.Provider value={data as any}>
      {children}
    </XArticleContext.Provider>
  );
};

export default XArticleProvider;
